import axios from "axios";
import { SERVER_URL } from "./../env";
import router from "./../router";

export default {
  state: {
    articleIsLoading: false,
    articleIsErrored: false,
    article: null,
    articleTags: [],
    commentText: "",
    commentIsSending: false,
    commentIsErrored: false,
    commentParentId: null
  },

  getters: {
    articleIsLoading: state => state.articleIsLoading,
    articleIsErrored: state => state.articleIsErrored,
    article: state => state.article,
    commentText: state => state.commentText,
    commentParent: state => {
      return state.article.comments.find(c => {
        return c.id === state.commentParentId;
      });
    }
  },

  mutations: {
    articleIsLoading: state => {
      state.articleIsLoading = true;
      state.articleIsErrored = false;
    },
    articleIsLoaded: state => {
      state.articleIsLoading = false;
    },
    articleIsErrored: state => {
      state.articleIsLoading = false;
      state.articleIsErrored = true;
    },
    setArticle: (state, payload) => {
      state.article = payload;
    },
    clearArticle: state => {
      state.article = {};
    },
    setArticleTags: (state, payload) => {
      state.articleTags = payload;
    },
    clearArticleTags: state => {
      state.articleTags = [];
    },
    updateCommentText: (state, payload) => {
      state.commentText = payload;
    },
    commentIsSending: state => {
      state.commentIsSending = true;
      state.commentIsErrored = false;
    },
    commentIsSent: state => {
      state.commentIsSending = false;
      state.commentParentId = null;
      state.commentText = "";
    },
    commentIsErrored: state => {
      state.commentIsSending = false;
      state.commentIsErrored = true;
    },
    replyOnComment: (state, payload) => {
      state.commentParentId = payload;
    },
    addComment: (state, payload) => {
      if (!state.article.comments) state.article.comments = [];
      state.article.comments.push(payload);
    }
  },

  actions: {
    async getArticle({ commit, dispatch }, id) {
      commit("articleIsLoading");
      try {
        const res = await axios.get(`${SERVER_URL}/api/post/${id}`);
        commit("setArticle", { ...res.data });
        commit("articleIsLoaded");
      } catch (e) {
        dispatch("setHttpError", e);
        commit("articleIsErrored");
      }
    },

    async sendComment({ state, commit, dispatch, rootGetters }) {
      try {
        const commentJson = {
          parent_id: state.commentParentId,
          post_id: state.article.id,
          text: state.commentText
        };

        commit("commentIsSending");

        const res = await axios.post(`${SERVER_URL}/api/comment`, commentJson);

        if (res.data.id) {
          const comment = {
            id: res.data.id,
            timestamp: new Date().getTime() / 1000,
            user: {
              id: rootGetters.user.id,
              name: rootGetters.user.name,
              photo: rootGetters.user.photo
            },
            text: rootGetters.commentText
          };

          commit("addComment", comment);
        }

        commit("commentIsSent");
      } catch (e) {
        commit("commentIsErrored");
        dispatch("setHttpError", e);
      }
    },

    async addPost({ dispatch }, payload) {
      try {
        const res = await axios.post(`${SERVER_URL}/api/post`, payload);
        if (res.data.result === true) {
          router.go(-1);
          return true;
        }
        dispatch("handleResultFalseError", res.data);
      } catch (error) {
        dispatch("setHttpError", error);
      }
    },

    async editPost({ dispatch }, { post, url }) {
      try {
        const res = await axios.put(`${SERVER_URL}/api/post/${url}`, post);
        if (res.data.result === true) {
          router.go(-1);
          return true;
        }
        dispatch("handleResultFalseError", res.data);
      } catch (e) {
        dispatch("setHttpError", e);
      }
    }
  }
};
